import { useEffect, useState } from 'react';
export const getPersistedValue = (storageString, defaultValue) => {
  try {
    var _ref;
    const value = localStorage.getItem(storageString);
    return (_ref = value && JSON.parse(value)) !== null && _ref !== void 0 ? _ref : defaultValue;
  } catch (error) {
    console.error('ProseMirror Local Storage Read Error', error, storageString, defaultValue);
    return defaultValue || null;
  }
};
export const setPersistedValue = (storageString, value) => {
  try {
    localStorage.setItem(storageString, JSON.stringify(value));
  } catch (error) {
    console.error('ProseMirror Local Storage Write Error', error, storageString, value);
  }
};
export const usePersistedValue = (key, defaultValue) => {
  const [state, setState] = useState(() => {
    return getPersistedValue(key, defaultValue);
  });
  useEffect(() => {
    setPersistedValue(key, state);
  }, [state, key]);
  return [state, setState];
};